import { atom } from "jotai";
import { addError } from "@zapier/observability";

import { canvasAtom } from "./canvasAtom";
import { nodesAtom } from "../nodes";
import { edgesAtom } from "../edges";
import { createNotificationSetter } from "../notifications";

export const exportCanvasSetter = atom(null, (get, set) => {
  const canvas = get(canvasAtom);
  const nodes = get(nodesAtom);
  const edges = get(edgesAtom);

  const fileName = canvas.name
    ? `${canvas.name.replace(/[^a-zA-Z0-9]/g, "_")}_canvas_export.json`
    : "canvas_export.json";

  try {
    const canvasExport = {
      canvas: {
        id: canvas.id,
        name: canvas.name,
        description: canvas.description,
        account_id: canvas.account_id,
        created: canvas.created,
        lastchanged: canvas.lastchanged,
        is_public: canvas.is_public,
        access_level: canvas.access_level,
      },
      nodes: nodes,
      edges: edges,
      exportedAt: new Date().toISOString(),
    };

    const jsonContent = JSON.stringify(canvasExport, null, 2);
    const blob = new Blob([jsonContent], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.download = fileName;
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    return { success: true, fileName };
  } catch (error) {
    console.error("Failed to export canvas:", error);

    // Show error notification
    addError(error, {
      tags: {
        canvasId: canvas.id,
      },
    });

    set(createNotificationSetter, {
      type: "error",
      message: "There was a problem exporting your canvas. Please try again.",
    });

    return { success: false, error };
  }
});
